import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FichaDepositoBancoList } from "./components/fichasdeposito/list";

type Entity = models.DepositoBancoDTO;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    onGuardarSinContabilizar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class DepositoBancoFormNoRx extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    contabilizado = (x: Props) => !x.value.PendienteContabilizar;

    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }


    importeDeposito = (x: Props) => x.value.ImporteDeposito;
    importeDepositoTotal = (x: Props) => x.value.ImporteTotal;
    importeGuiasPP = (x: Props) => x.value.ImporteGuiasPP;
    fichasDeposito = (x: Props) => x.value.FichasDepositoBanco;
    totalFichasDeposito = createSelectorRx(this.fichasDeposito, fichas => fichas.length > 0 ?
        fichas.map(x => x.Monto).reduce(function (acc, val) { return acc + val; })
        : 0);

    depositosIguales = createSelectorRx(this.importeDeposito, this.totalFichasDeposito, (importeDeposito, importefichas) => Math.abs(importeDeposito - importefichas) < 0.00001);
    depositosIgualesConTotalPP = createSelectorRx(this.importeDepositoTotal, this.totalFichasDeposito, (importeDeposito, importefichas) => Math.abs(importeDeposito - importefichas) < 0.00001);

    render() {
        const { value, onGuardar, onGuardarSinContabilizar, nuevo } = this.props;
        const getField = this.getField;
        const soloLectura = this.contabilizado(this.props);

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const DateTime = getField(kea.DateTime);
        const FichasDeposito = getField(FichaDepositoBancoList);
        const totalFichas = this.totalFichasDeposito(this.props);

        const depositosIguales = this.depositosIguales(this.props);
        const depositosIgualesConPP = this.depositosIgualesConTotalPP(this.props);

        return (
            <div>
                <kea.Title titulo="Contabilizar deposito banco" onRegresar={() => history.go('../')} />
                {kea.autogrid(3, [
                    <DateTime field="Fecha" label="Fecha del deposito:" readonly />,
                    <Text field="NombreUsuario" label="Nombre usuario:" readonly />,
                    <Text field="NombreSucursal" label="Nombre sucursal:" readonly />,
                    <Number field="ImporteDeposito" label="Importe del deposito de banco (Documentación, ocurre y EAD):" readonly />,

                    <Number field="ImporteGuiasPP" label="Importe de guiasPP ligadas al corte:" readonly />,
                    <Number field="ImporteTotal" label="Importe total:" readonly />,


                ])}
                <kea.Number label="Monto total fichas de pago:" value={totalFichas} readonly />,
                <FichasDeposito field="FichasDepositoBanco" readonly={soloLectura} />
                {
                    !soloLectura &&
                    <div className="row">
                        <div className="col-md-12">
                            <kea.GuardarButton onClick={onGuardar} disabled={ !depositosIgualesConPP } />
                            <kea.Button children="Guardar deposito sin contabilizar" style="primary" onClick={onGuardarSinContabilizar} />
                        </div>
                    </div>
                }
            </div>);
    }
}

export const DepositoBancoForm = componentToRx(DepositoBancoFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/depositobanco/edit/form.tsx